import React from 'react';

export default function AppExample(props) {
  return(
    <div>This is another component passed into the 'conent' prop</div>
  );
}



// WEBPACK FOOTER //
// ./demo/src/Example.js